/**
 * Conversation limit ("modo cola") — R7, realtime side of spec §4.
 *
 * The backend restricts a restricted agent's inbox to its seats when there is
 * no search text. Pusher still delivers `newMessage`/`newClient` events for
 * the agent's backlog, so without this filter the list would show 6 chats
 * live and 5 after a reload ("los chats aparecen y desaparecen").
 *
 * Reads the store only; lives outside the ducks to avoid an import cycle
 * between conversationsDuck and conversationLimitDuck.
 */
import { isRestrictedAgent } from './roles';

const hasSearchText = (searchFilter) => typeof searchFilter === 'string' && searchFilter.trim() !== '';

export const shouldIgnoreRealtimeConversation = (state, clientId) => {
  const limitState = state && state.conversationLimit;
  if (!limitState || limitState.enabled !== true) return false;
  if (typeof clientId !== 'string' || !clientId) return false;
  if (!isRestrictedAgent(state.user && state.user.data)) return false;

  const conversations = state.conversations || {};
  if (hasSearchText(conversations.searchFilter)) return false;
  if (conversations.current && conversations.current.id === clientId) return false;

  const seatIds = Array.isArray(limitState.seatIds) ? limitState.seatIds : [];
  return !seatIds.includes(clientId);
};

/**
 * True when a realtime event carries the very message the row already shows
 * as its last one. A just-seated conversation is fetched WITH its unread
 * message, and the `newMessage` event for that same message can land right
 * after: counting it again doubled the unread badge. Scoped to the feature
 * being on, so every other company keeps today's counting untouched.
 */
export const isRealtimeMessageAlreadyCounted = (state, row, data) => {
  const limitState = state && state.conversationLimit;
  if (!limitState || limitState.enabled !== true) return false;
  const incomingId = data && data.client && data.client.lastMessage && data.client.lastMessage.id;
  const shownId = row && row.lastMessage && row.lastMessage.id;
  return typeof incomingId === 'string' && incomingId !== '' && incomingId === shownId;
};
